// extracted by mini-css-extract-plugin
export default {"line":"NewsListItem_line__gRLpP","fio":"NewsListItem_fio__MpClK"};